[
    {
        "id": 0,
        "name": "OK",
        "color": "#b3b3b3"
    },
    {
        "id": 1,
        "name": "Defect",
        "color": "#9ef751"
    }
]
